function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameLogTemplate = require('./game-log.template');

/**
 * Creates a sidebar window for a reverse-ordered list of moves that have occurred in the game.
 * By default, only displays the most recent 150 log messages and will refuse to display consecutive identical messages
 * Included in GameTemplate by default and accessible through property: log.
 * Functionality completely encoded within gameTemplate through wrapper functions updateLog (to add a message)
 * but must call render (in initializeHTML) when we want a log in our game
 *
 */
var GameLog = /*#__PURE__*/function () {
  /**
   *  @constructor
   *  @param app - Saito app
   *  @param mod - reference to the game module
   */
  function GameLog(app, mod) {
    _classCallCheck(this, GameLog);
    this.app = app;
    this.game_mod = mod;
    this.rendered = false;
    this.logs = [];
    this.log_length = 150;
    this.logs_last_msg = '';
    this.event_listeners = {};
  }

  /**
   * Adds Log to the DOM
   */
  return _createClass(GameLog, [{
    key: "render",
    value: function render() {
      var _this = this;
      try {
        if (this.logs.length === 0) {
          this.logs = _toConsumableArray(this.game_mod.game.log);
        }
      } catch (err) {}
      if (this.logs_last_msg === '' && this.logs.length > 0) {
        this.logs_last_msg = this.entryText(this.logs[0]);
      }
      if (!document.querySelector('#log')) {
        this.app.browser.addElementToDom(GameLogTemplate());
        this.attachEvents();
      }
      var log = document.getElementById('log');
      if (log) {
        log.innerHTML = this.logs.slice(0, this.log_length).map(function (line) {
          return "<div>> ".concat(_this.renderEntry(line), "</div>");
        }).join('');
      } else {
        console.error('Unable to render game log');
      }
      this.rendered = true;
    }

    /**
     * Adds functionality to open/close log by clicking (with some tolerance for click-drag actions).
     * A disclosure summary only toggles its own entry. A drag that selects text does not close the log.
     */
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var xpos = 0;
      var ypos = 0;
      var log = document.querySelector('#log');
      log.onmousedown = function (e) {
        xpos = e.clientX;
        ypos = e.clientY;
      };
      log.onmouseup = function (e) {
        if (e.target && e.target.closest && e.target.closest('summary')) {
          return;
        }
        if (Math.abs(xpos - e.clientX) > 4 || Math.abs(ypos - e.clientY) > 4) {
          return;
        }
        var selection = window.getSelection ? window.getSelection() : null;
        if (selection && !selection.isCollapsed && String(selection).length > 0) {
          return;
        }
        _this2.toggleLog();
      };
      document.querySelector('.mobile-log-tab').onclick = function (e) {
        _this2.toggleLog();
      };
    }

    /**
     * Internal function to toggle display of the log
     */
  }, {
    key: "toggleLog",
    value: function toggleLog() {
      document.querySelector('#log-wrapper').classList.toggle('log-lock');
    }

    /**
     * Prepend a log entry and re-render.
     * An event type is stored with the entry. It changes rendering only when a listener is registered for that type.
     * @param log_str - the message to prepend to the log
     * @param eventType - optional event type, ignored when no listener is registered
     * @param data - optional structured payload stored with a typed entry
     */
  }, {
    key: "updateLog",
    value: function updateLog(log_str) {
      var eventType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      this.logs_last_msg = log_str;
      var type = typeof eventType === 'string' ? eventType.trim() : '';
      if (type) {
        this.logs.unshift({
          msg: log_str,
          type: type,
          data: data
        });
      } else {
        this.logs.unshift(log_str);
      }
      this.render(this.app, this.game_mod);
    }

    /**
     * Register a renderer for one event type.
     * The listener is called from render with an array of the entries for that line.
     * It should return the HTML string for the line. Any other return value leaves the plain message in place.
     * @param type - event type passed to updateLog
     * @param listener - function(entries) => string
     */
  }, {
    key: "registerEventType",
    value: function registerEventType(type, listener) {
      if (!type || typeof listener !== 'function') {
        return;
      }
      this.event_listeners[type] = listener;
      if (this.rendered) {
        this.render();
      }
    }
  }, {
    key: "entryText",
    value: function entryText(entry) {
      if (entry != null && _typeof(entry) === 'object') {
        return entry.msg != null ? entry.msg : '';
      }
      return entry != null ? entry : '';
    }
  }, {
    key: "renderEntry",
    value: function renderEntry(entry) {
      var text = this.entryText(entry);
      if (entry == null || _typeof(entry) !== 'object' || !entry.type) {
        return text;
      }
      var listener = this.event_listeners[entry.type];
      if (typeof listener !== 'function') {
        return text;
      }
      try {
        var interpreted = listener([entry]);
        if (typeof interpreted === 'string') {
          return interpreted;
        }
      } catch (err) {}
      return text;
    }
  }]);
}();
module.exports = GameLog;